import {
  SYSTEMCONFIG_GET_DICTIONARIES_LIST_BEGIN,
  SYSTEMCONFIG_GET_DICTIONARIES_LIST_SUCCESS,
  SYSTEMCONFIG_GET_DICTIONARIES_LIST_FAILURE,
  SYSTEMCONFIG_GET_DICTIONARIES_LIST_DISMISS_ERROR,
} from './constants';
import request from '../../../utils/request'
// Rekit uses redux-thunk for async actions by default: https://github.com/gaearon/redux-thunk
// If you prefer redux-saga, you can use rekit-plugin-redux-saga: https://github.com/supnate/rekit-plugin-redux-saga
export function getDictionariesList(params) {
  return (dispatch) => { // optionally you can have getState as the second argument
    dispatch({
      type: SYSTEMCONFIG_GET_DICTIONARIES_LIST_BEGIN,
    });

    // Return a promise so that you could control UI flow without states in the store.
    // For example: after submit a form, you need to redirect the page to another when succeeds or show some errors message if fails.
    // It's hard to use state to manage it, but returning a promise allows you to easily achieve it.
    // e.g.: handleSubmit() { this.props.actions.submitForm(data).then(()=> {}).catch(() => {}); }
    const promise = new Promise((resolve, reject) => {
      // doRequest is a placeholder Promise. You should replace it with your own logic.
      // See the real-word example at:  https://github.com/supnate/rekit/blob/master/src/features/home/redux/fetchRedditReactjsList.js
      // args.error here is only for test coverage purpose.
     request({
       url:'/api/dict?page=0&size=30&sort=id%2Cdesc',
       method:'get',
     }).then(
        (res) => {
          dispatch({
            type: SYSTEMCONFIG_GET_DICTIONARIES_LIST_SUCCESS,
            data: res,
          });
          resolve(res);
        },
        // Use rejectHandler as the second argument so that render errors won't be caught.
        (err) => {
          dispatch({
            type: SYSTEMCONFIG_GET_DICTIONARIES_LIST_FAILURE,
            data: { error: err },
          });
          reject(err);
        },
      );
    });

    return promise;
  };
}

// Async action saves request error by default, this method is used to dismiss the error info.
// If you don't want errors to be saved in Redux store, just ignore this method.
export function dismissGetDictionariesListError() {
  return {
    type: SYSTEMCONFIG_GET_DICTIONARIES_LIST_DISMISS_ERROR,
  };
}

export function reducer(state, action) {
  switch (action.type) {
    case SYSTEMCONFIG_GET_DICTIONARIES_LIST_BEGIN:
      // Just after a request is sent
      return {
        ...state,
        getDictionariesListPending: true,
        getDictionariesListError: null,
      };

    case SYSTEMCONFIG_GET_DICTIONARIES_LIST_SUCCESS:
      
      // 
      let content = action.data.content;
      let contentMap = {}
      content.map(item => {
         contentMap[item.id] = item;
      })

      return {
        ...state,
        getgetDictionariesMap: contentMap,
        getDictionariesLists:action.data,
        getDictionariesListPending: false,
        getDictionariesListError: null,
      };

    case SYSTEMCONFIG_GET_DICTIONARIES_LIST_FAILURE:
      // The request is failed
      return {
        ...state,
        getDictionariesListPending: false,
        getDictionariesListError: action.data.error,
      };

    case SYSTEMCONFIG_GET_DICTIONARIES_LIST_DISMISS_ERROR:
      // Dismiss the request failure error
      return {
        ...state,
        getDictionariesListError: null,
      };

    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/features/systemconfig/redux/getDictionariesList.js